import * as FileSaver from 'file-saver';
import XLSX from  'sheetjs-style';

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

export const downloadExcell = async ({newData, fileName}) => {
    console.log(fileName + '.xlsx')
    const ws = XLSX.utils.json_to_sheet(newData);
    const wb = { Sheets: {'data': ws}, 'SheetNames': ['data']};
    const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
    const data_download = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data_download, fileName + '.xlsx');
}
